export default ({ label, value, children, className = "", textareaClassName = ""}) => (
  <div className={ className || "flex flex-col items-center mb-2"}>
    { label && <label className="block text-sm font-medium text-gray-600 mr-2 mb-1">
      {label} :
    </label>}
    <div className={`textarea textarea-bordered w-full ${textareaClassName}`}>
      <pre className="text-balance">
        {children || value || ""}
      </pre>
    </div>
  </div>
)